const $ = window.jQuery;
const SELECTOR = '.grnhse-apply-button';

function onDocumentReady() {
	$(document).on('click', SELECTOR, onClickApplyButton);
}

function onClickApplyButton(e) {
	const clicked = $(e.currentTarget);

	if (clicked.closest('.flexible-layout.career-listing.target-blank').length > 0) {
		return true;
	}

	e.preventDefault();

	$.magnificPopup.open({
		mainClass: 'grnhse-app',
		items: {
			src: '#grnhse_app',
			type: 'inline',
		},
		callbacks: {
			open: function () {
				if (window.Grnhse) {
					window.Grnhse.Iframe.load();
				}
			},
		},
	});

	return false;
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
